import React from 'react';
import { CommercialSolutions } from '../components/CommercialSolutions';
export function CommercialPage() {
  return <main data-id="element-337">
      <CommercialSolutions data-id="element-338" />
    </main>;
}